import { UserService } from '../../../core/user/user.service';
import { AccountService } from '../../../core/auth/account.service';
import { Session } from '../../../shared/model/session.model';
import { JhiEventManager } from '../../../ng-jhipster/service';
import ZoomVideo from "@zoom/videosdk";
import { BaseComponent } from '../../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ZoomService } from '../zoom.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../../core/user/user.service";
import * as i4 from "../../../core/auth/account.service";
import * as i5 from "../../../ng-jhipster/service";
import * as i6 from "../zoom.service";
import * as i7 from "@angular/common";
import * as i8 from "../turned-off-video/turned-off-video.component";
import * as i9 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i10 from "@angular/material/slide-toggle";
import * as i11 from "@fortawesome/angular-fontawesome";
import * as i12 from "../virtual-background-selector/virtual-background-selector.component";
function CameraPreviewComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "turned-off-video", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.windowWidth > ctx_r0.screenThreshold ? "no-camera-div-desktop" : "no-camera-div-mobile");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("user", ctx_r0.currentUser);
} }
function CameraPreviewComponent_div_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16, 17);
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 11);
    i0.ɵɵelement(4, "use", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(5, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 21);
    i0.ɵɵelementStart(7, "div", 22);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9, "Effects");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 23);
    i0.ɵɵlistener("click", function CameraPreviewComponent_div_6_div_6_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r6); const _r4 = i0.ɵɵreference(1); return _r4.close(); });
    i0.ɵɵelement(11, "fa-icon", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "virtual-background-selector", 25);
    i0.ɵɵlistener("virtualBackgroundSelected", function CameraPreviewComponent_div_6_div_6_Template_virtual_background_selector_virtualBackgroundSelected_13_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.showVirtualBackgroundPreview($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CameraPreviewComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 11);
    i0.ɵɵelement(3, "use", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(4, "span", 13);
    i0.ɵɵelementStart(5, "mat-slide-toggle", 14);
    i0.ɵɵlistener("toggleChange", function CameraPreviewComponent_div_6_Template_mat_slide_toggle_toggleChange_5_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.toggleCamera(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CameraPreviewComponent_div_6_div_6_Template, 14, 0, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.virtualBackgroundEnabled ? "justify-content-between" : "justify-content-center");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("checked", ctx_r1.isCameraOn);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.virtualBackgroundEnabled);
} }
function CameraPreviewComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 11);
    i0.ɵɵelement(3, "use", 12);
    i0.ɵɵelement(4, "use", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(5, "span", 28);
    i0.ɵɵelementStart(6, "mat-slide-toggle", 29);
    i0.ɵɵlistener("toggleChange", function CameraPreviewComponent_div_7_Template_mat_slide_toggle_toggleChange_6_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.toggleCamera(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", !ctx_r2.deviceId)("checked", ctx_r2.isCameraOn);
} }
export class CameraPreviewComponent extends BaseComponent {
    constructor(sessionStorage, modalService, userService, accountService, eventManager, zoomService) {
        super(sessionStorage, modalService);
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.userService = userService;
        this.accountService = accountService;
        this.eventManager = eventManager;
        this.zoomService = zoomService;
        this.screenThreshold = 1024;
        this.selectedVirtualBackground = 'NONE';
        // Zoom doesn't support virtual background in preview mode, we can apply the VirtualBackground
        // only after Client.init (which takes time to load all JS assents)
        // https://devforum.zoom.us/t/virtual-background-not-working-in-preview-camera/81923
        // https://devforum.zoom.us/t/cant-start-preview-localvideotrack-without-background-with-canvas/101674/8
        this.virtualBackgroundEnabled = false;
        // this.virtualBackgroundEnabled = this.zoomService.isVirtualBackgroundEnabled();
    }
    set deviceId(value) {
        if (value && value !== this._deviceId) {
            this._deviceId = value;
            this.previewVideo();
        }
    }
    get deviceId() {
        return this._deviceId;
    }
    set session(value) {
        this._session = value;
    }
    get session() {
        return this._session;
    }
    ngOnInit() {
        if (this.isUser()) {
            this.currentUser = this.session.user;
        }
        else {
            this.currentUser = this.session.coach;
        }
        console.log(this.windowWidth);
    }
    isUser() {
        return this.accountService.isUser();
    }
    isCoach() {
        return this.accountService.isCoach();
    }
    previewVideo() {
        var _a, _b;
        if (this.localVideoTrack) {
            (_a = this.localVideoTrack) === null || _a === void 0 ? void 0 : _a.stop().then();
            this.localVideoTrack = null;
        }
        if (this.localVideoTrackWithVirtualBackground) {
            (_b = this.localVideoTrackWithVirtualBackground) === null || _b === void 0 ? void 0 : _b.stop().then();
            this.localVideoTrackWithVirtualBackground = null;
        }
        if (this.selectedVirtualBackground === 'NONE') {
            this.startPreviewVideo();
        }
        else {
            this.startPreviewVideoWithVirtualBackground();
        }
    }
    startPreviewVideo() {
        this.isCameraOn = true;
        this.localVideoTrack = ZoomVideo.createLocalVideoTrack(this.deviceId);
        this.localVideoTrack.start(document.querySelector('#preview-camera-video')).then().catch(reason => {
            console.warn('failed to start video preview');
            console.warn(reason);
            if (reason &&
                (reason.toString().includes('Could not start video source') || reason.toString().includes('Starting videoinput failed'))) {
                this.zoomService.showCameraIsInUseError();
            }
            this.isCameraOn = false;
        });
        this.zoomService.turnOnVideo();
    }
    stopPreviewVideo() {
        var _a, _b;
        this.isCameraOn = false;
        (_a = this.localVideoTrack) === null || _a === void 0 ? void 0 : _a.stop().then();
        (_b = this.localVideoTrackWithVirtualBackground) === null || _b === void 0 ? void 0 : _b.stop().then();
        this.zoomService.turnOfVideo();
    }
    toggleCamera() {
        this.isCameraOn = !this.isCameraOn;
        if (this.isCameraOn) {
            this.startPreviewVideo();
        }
        else {
            this.stopPreviewVideo();
        }
    }
    ngOnDestroy() {
        var _a, _b, _c;
        if (this.isCameraOn) {
            (_a = this.localVideoTrack) === null || _a === void 0 ? void 0 : _a.stop().then();
            (_b = this.localVideoTrackWithVirtualBackground) === null || _b === void 0 ? void 0 : _b.stop().then();
        }
        (_c = this.virtualBackgroundSupportStatusSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
    }
    showVirtualBackgroundPreview(virtualBackgroundType) {
        if (this.localVideoTrackWithVirtualBackground) {
            this.localVideoTrackWithVirtualBackground.updateVirtualBackground(this.zoomService.getVirtualBackgroundImageUrl(virtualBackgroundType)).then(value => {
                this.selectedVirtualBackground = virtualBackgroundType;
                this.zoomService.changeVirtualBackground(virtualBackgroundType);
            });
        }
        else {
            this.localVideoTrack.stop().then(value => {
                this.selectedVirtualBackground = virtualBackgroundType;
                this.zoomService.changeVirtualBackground(virtualBackgroundType);
                this.startPreviewVideoWithVirtualBackground();
            });
        }
    }
    startPreviewVideoWithVirtualBackground() {
        const localVideoTrackWithVirtualBackground = ZoomVideo.createLocalVideoTrack(this.deviceId);
        localVideoTrackWithVirtualBackground.start(document.querySelector('#preview-camera-canvas'), {
            imageUrl: this.zoomService.getVirtualBackgroundImageUrl(this.selectedVirtualBackground)
        }).then(value1 => {
            this.localVideoTrackWithVirtualBackground = localVideoTrackWithVirtualBackground;
        }).catch(reason => {
            console.warn('failed to start video preview');
            console.warn(reason);
            if (reason &&
                (reason.toString().includes('Could not start video source') || reason.toString().includes('Starting videoinput failed'))) {
                this.zoomService.showCameraIsInUseError();
            }
            this.isCameraOn = false;
        });
    }
}
CameraPreviewComponent.ɵfac = function CameraPreviewComponent_Factory(t) { return new (t || CameraPreviewComponent)(i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.UserService), i0.ɵɵdirectiveInject(i4.AccountService), i0.ɵɵdirectiveInject(i5.JhiEventManager), i0.ɵɵdirectiveInject(i6.ZoomService)); };
CameraPreviewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CameraPreviewComponent, selectors: [["camera-preview"]], inputs: { width: "width", height: "height", isCameraOn: "isCameraOn", deviceId: "deviceId", session: "session" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 13, consts: [[3, "ngClass"], ["id", "preview-camera-video", "playsinline", "", 3, "ngClass"], ["id", "preview-camera-canvas", 3, "ngClass", "height", "width"], ["class", "d-flex justify-content-center align-items-center no-camera-div", 3, "ngClass", 4, "ngIf"], [1, "camera-notification", 3, "ngClass"], [1, "m-1"], ["class", "d-flex align-items-center", 3, "ngClass", 4, "ngIf"], ["class", "d-flex align-items-center justify-content-center", 4, "ngIf"], [1, "d-flex", "justify-content-center", "align-items-center", "no-camera-div", 3, "ngClass"], [2, "width", "50%", 3, "user"], [1, "d-flex", "align-items-center", 3, "ngClass"], ["width", "22", "height", "22"], ["id", "actual-icon", 0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#video-call-dark-20"], ["jhiTranslate", "sessionChat.paragraph.cameraOn", 1, "ml-2", 2, "margin-bottom", "2px"], [1, "ml-2", 3, "checked", "toggleChange"], ["ngbDropdown", "", "placement", "top-right", "class", "d-inline-block", 4, "ngIf"], ["ngbDropdown", "", "placement", "top-right", 1, "d-inline-block"], ["virtualBackgroundPreview", "ngbDropdown"], ["ngbDropdownToggle", "", 1, "virtual-background-preview-toggler", "d-flex", "align-items-center"], ["id", "actual-icon", 0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#gear-solid"], ["jhiTranslate", "sessionChat.paragraph.virtualBackgrounds", 1, "ml-2", 2, "margin-bottom", "2px"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownBasic2", 2, "width", "270px", "padding", "10px"], [1, "d-flex", "justify-content-between"], [2, "color", "#8A9D98", "cursor", "pointer", 3, "click"], ["icon", "times-circle"], [3, "virtualBackgroundSelected"], [1, "d-flex", "align-items-center", "justify-content-center"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#diagonal"], ["jhiTranslate", "sessionChat.paragraph.cameraOff", 1, "ml-2", 2, "margin-bottom", "2px"], [1, "ml-2", 3, "disabled", "checked", "toggleChange"]], template: function CameraPreviewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "video", 1);
        i0.ɵɵelement(2, "canvas", 2);
        i0.ɵɵtemplate(3, CameraPreviewComponent_div_3_Template, 2, 2, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, CameraPreviewComponent_div_6_Template, 7, 3, "div", 6);
        i0.ɵɵtemplate(7, CameraPreviewComponent_div_7_Template, 7, 2, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.windowWidth > ctx.screenThreshold ? "camera-preview-div-desktop" : "camera-preview-div-mobile");
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", !ctx.deviceId || !ctx.isCameraOn || ctx.localVideoTrackWithVirtualBackground);
        i0.ɵɵproperty("ngClass", ctx.windowWidth > ctx.screenThreshold ? "preview-camera-video-desktop" : "preview-camera-video-mobile");
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", !ctx.deviceId || !ctx.isCameraOn || !ctx.localVideoTrackWithVirtualBackground);
        i0.ɵɵproperty("ngClass", ctx.windowWidth > ctx.screenThreshold ? "preview-camera-video-desktop" : "preview-camera-video-mobile")("height", ctx.height)("width", ctx.width);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isCameraOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.windowWidth > ctx.screenThreshold ? "camera-notification-desktop" : "camera-notification-mobile");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isCameraOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isCameraOn);
    } }, directives: [i7.NgClass, i7.NgIf, i8.TurnedOffVideoComponent, i9.JhiTranslateDirective, i10.MatSlideToggle, i2.NgbDropdown, i2.NgbDropdownToggle, i2.NgbDropdownMenu, i11.FaIconComponent, i12.VirtualBackgroundSelectorComponent], styles: [".camera-notification[_ngcontent-%COMP%]{padding:5px 10px;font-weight:700;font-size:16px;position:relative;bottom:48px;width:100%;text-align:center}#preview-camera-video[_ngcontent-%COMP%]{background-color:#000}.camera-notification-desktop[_ngcontent-%COMP%]{background:#fcfbf7;color:#0a4a3a;border-radius:0 0 6px 6px}.camera-notification-mobile[_ngcontent-%COMP%]{background:#44a38b;color:#fff}.line[_ngcontent-%COMP%]{position:absolute;width:20px;height:20px;left:calc(50% - 20px/2);top:calc(50% - 20px/2);border:2px solid #af3b6e}.first-letter[_ngcontent-%COMP%]{border-radius:50%;background-color:#44a38b;font-weight:900 !important;color:#fff}.first-letter[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-size:180px}.camera-preview-div-desktop[_ngcontent-%COMP%]{margin-right:30px}.camera-preview-div-desktop[_ngcontent-%COMP%]   #preview-camera-video[_ngcontent-%COMP%]{width:auto !important}.camera-preview-div-mobile[_ngcontent-%COMP%]{width:100vw}.camera-preview-div-mobile[_ngcontent-%COMP%]   #preview-camera-video[_ngcontent-%COMP%]{width:100% !important}.preview-camera-video-desktop[_ngcontent-%COMP%]{height:673px !important;margin-right:0;border-radius:10px}.preview-camera-video-mobile[_ngcontent-%COMP%]{max-height:60vh}.no-camera-div[_ngcontent-%COMP%]{background:#dff1ec}.no-camera-div-desktop[_ngcontent-%COMP%]{border-radius:10px;height:673px;width:897px}.no-camera-div-mobile[_ngcontent-%COMP%]{height:300px;width:100vw}.no-camera[_ngcontent-%COMP%]{width:300px !important;height:300px !important;border-radius:50%;background:#44a38b}.virtual-background-preview-toggler[_ngcontent-%COMP%]{cursor:pointer}.virtual-background-preview-toggler.dropdown-toggle[_ngcontent-%COMP%]::after{display:none}[_nghost-%COMP%]     .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar{background:#0a4a3a}[_nghost-%COMP%]     .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background:#fff}[_nghost-%COMP%]     .mat-slide-toggle .mat-slide-toggle-bar{background-color:#e1e1e1}[_nghost-%COMP%]     .mat-slide-toggle .mat-slide-toggle-thumb{background-color:#fff}"] });
